<label [for]="fieldId"
       [class.mandatory]="isMandatory()">
  {{ label }}
</label>
<select [id]="fieldId"
        [formControl]="control"
        [class.is-invalid]="isInvalid()"
        appSaveLastFocussedConditionally [saveLastFocussedEnabled]="saveLastFocusedEnabled"
        class="form-select form-select-sm"
        [ngbPopover]="assistantServiceEnabled ? popOverName : ''">
  <option value=""></option>
  <option *ngFor="let listItem of items" value="{{ listItem.key }}">{{ listItem.value }}</option>
</select>
<ng-template #popOverName>
  <app-assistant (assistantDisabled)="disableAssistant()">
    <ng-content></ng-content>
  </app-assistant>
</ng-template>
